import { render, staticRenderFns } from "./WhiteLabelHeader.vue?vue&type=template&id=98c4898c&scoped=true"
import script from "./WhiteLabelHeader.vue?vue&type=script&lang=js"
export * from "./WhiteLabelHeader.vue?vue&type=script&lang=js"
import style0 from "./WhiteLabelHeader.vue?vue&type=style&index=0&id=98c4898c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c4898c",
  null
  
)

export default component.exports